import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Params, Router } from '@angular/router';
// 3rdparty
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subject, Subscription, combineLatest, forkJoin, takeUntil } from 'rxjs';
// Hostware
import { HttpErrorResponse } from '@angular/common/http';
import { PayStartRq } from '@app/dto/PayStartRequest';
import { PayStartResponse } from '@app/dto/PayStartResponse';
import { RoomGuest } from '@app/dto/ReservationInfo';
import SessionStorage from '@app/helpers/SessionStorage';
import { Balance } from '@app/interfaces/Balance';
import { Charge, RoomStayCharge, StartBillingResponse } from '@app/interfaces/StartBillingResponse';
import { GenericMessage } from '@app/interfaces/generic-message';
import { BillingService } from '@app/services/billing.service';
import { SpinnerService } from '@app/services/spinner.service';
import { BalanceType } from '@app/types/Types';
import dayjs from 'dayjs';
import { CurrencySettings } from '../../../../../froexishared/src/dto/CurrencySettingsDto';
import { SubscriberParameter } from '../../../../../froexishared/src/dto/SubscriberParameter';
import { SubscriberParameterService } from '../../../../../froexishared/src/services/SubscriberParameter.service';
import { GenericMessageDialogComponent } from '../../dialogs/generic-message-dialog/generic-message-dialog.component';
import { SimpleVerificationDialogComponent } from '@app/dialogs/simple-verification-dialog/simple-verification-dialog.component';
import { YesNoDialogComponent } from '@app/dialogs/yes-no-dialog/yes-no-dialog.component';
import { BigFishPayMode } from '@app/interfaces/BigFishPayMode';
import { BigfishPaymentDialogComponent } from '@app/dialogs/bigfish-payment-dialog/bigfish-payment-dialog.component';
import { BigFish } from '@app/interfaces/BigFish';
import { formatNumber } from '@angular/common';
import { HeaderService } from '@app/services/header.service';
import { ServiceEditable } from '../../../../../froexishared/src/dto/Service';
import { HwServicesService } from '../../../../../froexishared/src/services/hw-services.service';
import { ServiceLight } from '@app/interfaces/ServiceLight';

@AutoUnsubscribe()
@Component({
  selector: 'bill-view',
  templateUrl: './bill-view.component.html',
  styleUrls: ['./bill-view.component.scss']
})
export class BillViewComponent implements OnInit, OnDestroy {

  loadBalance$: Subscription;
  destroy$: Subject<boolean> = new Subject<boolean>();

  startBillingRespose: StartBillingResponse;
  dataSource: MatTableDataSource<Balance>;
  selectedBalanceType: BalanceType;
  selection = new SelectionModel<Balance>(true, []);

  showDeposit: boolean = false;
  loaded: boolean = false;
  currencySettings: CurrencySettings;
  total: number = 0

  sumDeposit: number = 0
  paymentParameters: any;
  allowedPaymentType: string
  stripeParameters: StripeParameters;
  simpleParameters: SimpleParameters;
  bigFishPaymentParameters: BigFish;
  paymentProvider: string
  summarizedCharges: ChargeSummarizer[] = [];
  summarizedEURCharges: ChargeSummarizer[] = [];
  summarizedHUFCharges: ChargeSummarizer[] = [];
  filtered: RoomStayCharge[] = [];
  // excludedServices: string[] = [];
  services: ServiceEditable[] = [];
  excludedServices : ServiceLight[]=[]
  excludedServiceNames : string[]=[];
  sumExcluded: number = 0;
  sumExcludedEUR: number = 0;
  sumExcludedHUF: number = 0;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private subscriberParamaterService: SubscriberParameterService,
    private activatedRoute: ActivatedRoute,
    private billingService: BillingService,
    private spinnerService: SpinnerService,
    private headerService: HeaderService,
    private hwServicesService: HwServicesService,
    private dialog: MatDialog,
  ) { }



  //#region =============== Angular Lifecyle events ============================================================================
  ngOnInit() {
    this.headerService.setNavigationVisibility(true);
    this.showDeposit = true //this.queryParams["showdeposit"] == "true" ? true : false;
    this.headerService.navigationBack.subscribe(() => {

    })

    const selectedGuest = JSON.parse(sessionStorage.getItem('sgd')) as RoomGuest
    // alert('false vissza')
    this.selectedBalanceType = 'OUTSTANDING';
    this.spinnerService.setSpinnerVisibility(true);
    const combinedSources = forkJoin({
      startbillingResponse: this.billingService.StartBilling(selectedGuest.GuestStayUuId, SessionStorage.ActiveLanguage, false),
      currencySettings: this.subscriberParamaterService.loadByTypeCode(SessionStorage.ReservationInfo.Subscriber,
        parseInt(SessionStorage.ReservationInfo.Hotelid), "CURRENCY_SETTINGS"),
      paymentParameters: this.subscriberParamaterService.loadByTypeCode(SessionStorage.ReservationInfo.Subscriber,
        parseInt(SessionStorage.ReservationInfo.Hotelid), "PAYMENT_PARAMETERS"),
      paymentTypes: this.subscriberParamaterService.loadByTypeCode(SessionStorage.ReservationInfo.Subscriber,
        parseInt(SessionStorage.ReservationInfo.Hotelid), "PAYMENT_TYPE"),
      excludeds: this.subscriberParamaterService.loadByTypeCode(SessionStorage.ReservationInfo.Subscriber,
        parseInt(SessionStorage.ReservationInfo.Hotelid), "EXCLUDED_SERVICES"),
      services: this.hwServicesService.getServices(SessionStorage.ReservationInfo.Subscriber, parseInt(SessionStorage.ReservationInfo.Hotelid))

    }).pipe(takeUntil(this.destroy$)).subscribe({
      next: (values) => {
        this.startBillingRespose = values.startbillingResponse as StartBillingResponse;
        SessionStorage.TransactionId = this.startBillingRespose.Transaction.TransactionId;
        let subsparam = values.currencySettings as SubscriberParameter;
        const paymentParam = values.paymentParameters as SubscriberParameter;
        this.paymentParameters = JSON.parse(paymentParam.Param_Json_Value)

        const paymentType = values.paymentTypes as SubscriberParameter;
        this.allowedPaymentType = paymentType.Param_String_Value
        this.services = values.services as  ServiceEditable[]
        this.excludedServices = SessionStorage.ExcludedServiceNames;
        // this.excludedServiceNames =  [];
        // this.services.forEach(item=> {
        //   if( item.ExcSzep) {
        //     this.excludedServices.push(item)
        //     const serviceName = item.LangDescriptions.find(item=>item.Lang == SessionStorage.ActiveLanguage).ServiceDescription;
        //     this.excludedServiceNames.push(serviceName)
        //   }
        // })
        // if(this.excludedServiceNames.length>0) {
        //   SessionStorage.ExcludedServiceNames = this.excludedServiceNames;
        // } else {
        //   SessionStorage.ExcludedServiceNames = []
        // }
        // this.excludedServices = (values.excludeds as SubscriberParameter).Param_String_Value.split(",")
        switch (this.allowedPaymentType) {
          case "SIMPLE":
            this.processSimplePayment();
            break;
          case "BIGFISH":
            this.bigFishPaymentParameters = JSON.parse(paymentParam.Param_Json_Value)["BIGFISH"] as BigFish
            this.processBigFishPayment();
            break;
        }
        this.currencySettings = JSON.parse(subsparam.Param_Json_Value) as CurrencySettings;

        // calculate total
        this.total = 0;
        if (SessionStorage.Invited == "Y") {
          this.filtered = this.startBillingRespose.Transaction.RoomStayCharges.filter(item => item.RoomId == SessionStorage.RoomId)
        }
        else {
          this.filtered = this.startBillingRespose.Transaction.RoomStayCharges;
        }

        this.filtered.forEach(charge => {
          charge.RoomStayCharges.forEach(roomCharge => {
            if (!this.canBePayed(roomCharge.ServiceId)) {
              this.sumExcluded = this.sumExcluded + (roomCharge.Amount)
            }

            if (roomCharge.Description?.trim().length == 0 || roomCharge.Description == null) {
              const huDescription = this.services.find(item => item.ServiceId.toString() == roomCharge.ServiceId).LangDescriptions
                .find(item => item.Lang == "hu").ServiceDescription;
              roomCharge.Description = huDescription
            }
            if (this.summarizedCharges.length === 0 && this.canBePayed(roomCharge.ServiceId)) {
              this.summarizedCharges.push({
                Amount: SessionStorage.Currency == "HUF" ? roomCharge.Amount : roomCharge.InvoiceAmount,
                ServiceId: roomCharge.ServiceId,
                ServiceIdCounter: roomCharge.Quantity,
                Description: roomCharge.Description,
                SumValue: SessionStorage.Currency == "HUF" ? roomCharge.Amount : roomCharge.InvoiceAmount
              })
              this.total += SessionStorage.Currency == "HUF" ? roomCharge.Amount : roomCharge.InvoiceAmount;
            } else {
              if (this.canBePayed(roomCharge.ServiceId)) {
                const foundIndex = this.summarizedCharges.findIndex(item => item.ServiceId == roomCharge.ServiceId)
                if (foundIndex == -1) {
                  this.summarizedCharges.push({

                    Amount: SessionStorage.Currency == "HUF" ? roomCharge.Amount : roomCharge.InvoiceAmount,
                    ServiceId: roomCharge.ServiceId,
                    ServiceIdCounter: roomCharge.Quantity,
                    Description: roomCharge.Description,
                    SumValue: SessionStorage.Currency == "HUF" ? roomCharge.Amount : roomCharge.InvoiceAmount,
                  })
                  this.total += SessionStorage.Currency == "HUF" ? roomCharge.Amount : roomCharge.InvoiceAmount;
                } else {
                  this.summarizedCharges[foundIndex].ServiceIdCounter += roomCharge.Quantity;
                  this.summarizedCharges[foundIndex].SumValue += (SessionStorage.Currency == "HUF" ? roomCharge.Amount : roomCharge.InvoiceAmount);
                  this.total += SessionStorage.Currency == "HUF" ? roomCharge.Amount : roomCharge.InvoiceAmount;
                }
              }

            }
          })
        })

        this.startBillingRespose.Transaction.RoomStayCharges.forEach(charge => {
          charge.GuestStayCharges.forEach(guestCharge => {
            guestCharge.GuestCharges.forEach(guestItemCharge => {
              if (!this.canBePayed(guestItemCharge.ServiceId)) {
                this.sumExcluded = this.sumExcluded + (SessionStorage.Currency == "HUF" ? guestItemCharge.Amount : guestItemCharge.InvoiceAmount)
              }

              if (this.canBePayed(guestItemCharge.ServiceId)) {
                this.summarizedCharges.push({
                  Amount: SessionStorage.Currency == "HUF" ? guestItemCharge.Amount : guestItemCharge.InvoiceAmount,
                  ServiceId: guestItemCharge.ServiceId,
                  ServiceIdCounter: guestItemCharge.Quantity,
                  Description: guestItemCharge.Description,
                  SumValue: SessionStorage.Currency == "HUF" ? guestItemCharge.Amount : guestItemCharge.InvoiceAmount,
                })
                this.total += SessionStorage.Currency == "HUF" ? guestItemCharge.Amount : guestItemCharge.InvoiceAmount;
              } else {
                if (!this.excludedServices.find(item => item.ServiceId.toString() == guestItemCharge.ServiceId)) {
                  const foundIndex = this.summarizedCharges.findIndex(item => item.ServiceId === guestItemCharge.ServiceId)
                  if (foundIndex == -1) {
                    this.summarizedCharges.push({
                      Amount: SessionStorage.Currency == "HUF" ? guestItemCharge.Amount : guestItemCharge.InvoiceAmount,
                      ServiceId: guestItemCharge.ServiceId,
                      ServiceIdCounter: guestItemCharge.Quantity,
                      Description: guestItemCharge.Description,
                      SumValue: SessionStorage.Currency == "HUF" ? guestItemCharge.Amount : guestItemCharge.InvoiceAmount,
                    })
                    this.total += SessionStorage.Currency == "HUF" ? guestItemCharge.Amount : guestItemCharge.InvoiceAmount;
                  } else {
                    this.summarizedCharges[foundIndex].ServiceIdCounter += guestItemCharge.Quantity;
                    this.summarizedCharges[foundIndex].SumValue += (SessionStorage.Currency == "HUF" ? guestItemCharge.Amount : guestItemCharge.InvoiceAmount);
                    this.total += SessionStorage.Currency == "HUF" ? guestItemCharge.Amount : guestItemCharge.InvoiceAmount;
                  }
                }
              }
            })
          })
        })
        this.startBillingRespose.Transaction.Deposits.forEach(deposit => {
          this.sumDeposit += (SessionStorage.Currency == "HUF" ? deposit.Amount : deposit.InvoiceAmount);
        })
        this.loaded = true
        this.spinnerService.setSpinnerVisibility(false);
      },
      error: err => {
        this.spinnerService.setSpinnerVisibility(false);
        let messageData: GenericMessage = { messageText: this.translate.instant('common.network_error'), messageType: 'ERROR', showIcon: true }
        const dialogRef = this.dialog.open(GenericMessageDialogComponent, {
          disableClose: true,
          hasBackdrop: true,
          minWidth: "auto",
          data: messageData
        })
      }
    })



  }
  ngOnDestroy(): void {
    this.loadBalance$?.unsubscribe();
  }
  //#endregion =================================================================================================================

  //#region =============== List event hadlers   ===============================================================================
  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================
  payClick() {
    // alert("Kivenni")
    // this.allowedPaymentType = "SIMPLE"
    // create payment  structure

    switch (this.allowedPaymentType) {
      case "SIMPLE":
        const dialog = this.dialog.open(SimpleVerificationDialogComponent, {
          id: 'simpleverification',
          disableClose: true,
          minWidth: "100vw",
          minHeight: "60vh"
        })
        dialog.afterClosed().subscribe(data => {
          if (data.result === 'acceptedPolicy') this.startPay(SessionStorage.UseDeposit == 'y' ? true : false, "SIMPLE");
        })
        break;
      case "BIGFISH":
        this.startPay(SessionStorage.UseDeposit == 'y' ? true : false, SessionStorage.SelectedPaymentMode)
        break;
    }

  }

  startPay(isDepositUsing: boolean, paymentType: string) {
    const invDetails = SessionStorage.InvoiceDetails;


    let payStartRequest: PayStartRq = {
      HwTransactionId: this.startBillingRespose.Transaction.TransactionId,
      PaymentType: paymentType,
      IsDepositUsing: isDepositUsing,
      VatOrigin: SessionStorage.InvoiceDetails.TaxableEntity, //  "M",
      Address: invDetails.Address,
      City: invDetails.City,
      Company: "",
      Country: invDetails.Country,
      CountryCode: invDetails.CountryCode,
      CustomerEmail: invDetails.Email,
      FirstName: invDetails.FirstName,
      LastName: invDetails.LastName,
      Phone: "+" + invDetails.PhonePrefix + invDetails.Phone,
      State: "",
      TaxNumber: invDetails.TaxNo,
      Zip: invDetails.Zip,
      HotelId: SessionStorage.GuestData.HotelId,
      Subscriber: SessionStorage.GuestData.Subscriber,
      Currency: SessionStorage.Currency,
      GuestIp: SessionStorage.IpAddress,

    }
    this.billingService.StartPayment(payStartRequest).subscribe({
      next: (startPayResult) => {
        let resp = startPayResult as PayStartResponse
        if (resp.ErrorCodes !== null && resp.ErrorCodes !== undefined) {
          let messageContent = this.translate.instant("payment." + resp.ErrorCodes[0])
          let messageData: GenericMessage = { messageText: messageContent, messageType: 'ERROR', showIcon: false }
          const dialogRef = this.dialog.open(GenericMessageDialogComponent, {
            disableClose: true,
            hasBackdrop: true,
            width: "auto",
            data: messageData
          })
        } else {
          //this.router.navigateByUrl(resp.paymentUrl);
          this.router.navigate(['/externalRedirect', { externalUrl: resp.PaymentUrl }]);

        }
      },
      error: (err: HttpErrorResponse) => {
        let messageData: GenericMessage = { messageText: this.translate.instant('common.network_error'), messageType: 'ERROR', showIcon: false }
        const dialogRef = this.dialog.open(GenericMessageDialogComponent, {
          disableClose: true,
          hasBackdrop: true,
          minWidth: "auto",
          data: messageData
        })
        this.dialog.getDialogById('simpleverification').close()
      },
    })

  }
  //#endregion =================================================================================================================

  //#region =============== Dialog events ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Validation    ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================

  formattedDate(dateString: string): string {
    return dayjs(dateString).locale(SessionStorage.ActiveLanguage).format('ll');
  }

  processSimplePayment() {
    this.simpleParameters = {
      CancelUrl: this.paymentParameters["SIMPLE"]["CancelUrl"],
      ClientUrl: this.paymentParameters["SIMPLE"]["ClientUrl"],
      FailUrl: this.paymentParameters["SIMPLE"]["FailUrl"],
      Merchant: this.paymentParameters["SIMPLE"]["Merchant"],
      MerchantKey: this.paymentParameters["SIMPLE"]["MerchantKey"],
      SuccessUrl: this.paymentParameters["SIMPLE"]["SuccessUrl"],
      TimeOutUrl: this.paymentParameters["SIMPLE"]["TimeOutUrl"]
    }

  }

  formattedValue(value: number): string {
    const locale = SessionStorage.Currency == "HUF" ? "hu-HU" : "en-US";
    if (SessionStorage.Currency == "HUF") {
      return formatNumber(value, locale, "0.0-0").replace(",", " ");
    } else {
      if (value == Math.round(value)) {
        return formatNumber(value, locale, "0.0-2").replace(".", ",") + ",00"
      } else {
        return formatNumber(value, locale, "0.0-2").replace(".", ",");
      }
    }
  }

  totalValue(): string {
    let toPayValue: number = this.total - this.sumDeposit;
    const locale = SessionStorage.Currency == "HUF" ? "hu-HU" : "en-US";
    if (SessionStorage.Currency == "HUF") {
      return formatNumber(toPayValue, locale, "0.0-0").replace(",", " ");
    } else {
      return formatNumber(toPayValue, locale, "0.0-2").replace(".", ",");
    }

    if (SessionStorage.Currency == "HUF") {
      return formatNumber(this.total - this.sumDeposit, "hu-HU", "0.0-0").replace(",", " ");
    }
  }
  currency(): string {
    return SessionStorage.Currency;
  }

  logoPath(): string {
    switch (this.allowedPaymentType) {
      case "SIMPLE":
        return "assets/logos/simplepay_w140.png"
      case "BIGFISH":
        return "assets/logos/nevogate.png"
    }
  }

  processBigFishPayment() {

  }

  canBePayed(serviceId: string): boolean {
    let ret: boolean = true;
    switch (SessionStorage.SelectedPaymentType) {
      case "CREDITCARD":
        return true
      case "SZEPCARD":
        return !this.excludedServices.find(item => item.ServiceId.toString() == serviceId)
    }
  }


  // balanceItemStyle(rst: RoomStayCharge) {
  //   let styles = {};
  //   styles["color"] = rst.Price > 0 ? 'black' : 'red'
  //   return styles;
  // }



  //#endregion =================================================================================================================

}

interface ChargeSummarizer {
  ServiceId: string;
  SumValue: number
  ServiceIdCounter: number;
  Description: string;
  Amount: number;

}

interface StripeParameters {
  CancelUrl: string;
  ClientUrl: string;
  FailUrl: string;
  Merchant: string;
  MerchantKey: string;
  SuccessUrl: string;
  TimeOutUrl: string;
}

interface SimpleParameters {
  FailUrl: string,
  Merchant: string,
  CancelUrl: string,
  ClientUrl: string,
  SuccessUrl: string,
  TimeOutUrl: string,
  MerchantKey: string
}